<div
    class="library-element"
    [ngClass]="{ 'library-element--preview': viewMode === MediaLibraryMode.preview }"
    [uiTooltip]="element | brandLibraryElementTooltip: element.type"
    uiTooltipTrigger="hover"
    [uiTooltipClass]="isVideo ? 'ml-tooltip-video' : 'ml-tooltip'"
    [uiTooltipPosition]="isVideo ? 'right' : 'top'"
    uiTooltipMaxWidth="175px">
    <ui-input
        #nameInput
        class="library-element__input"
        [minlength]="1"
        *ngIf="isEditingName && isSelected"
        (click)="stopPropagation($event)"
        (dblclick)="stopPropagation($event)"
        (mousedown)="stopPropagation($event)"
        (blur)="updateName(nameInput)"
        [selectTextOnFocus]="true"
        (keyup.enter)="nameInput.blurInput()"
        [value]="element.name"
        autocomplete="off"></ui-input>
    <div
        class="library-element__header library-element-row"
        *ngIf="!isEditingName">
        <ui-svg-icon
            class="library-element-row__icon"
            [icon]="elementIcon">
        </ui-svg-icon>
        <div
            class="library-element-row__name"
            (click)="editElementName($event)">
            {{ element.name }}
            <span
                class="library-element-video-duration-list"
                *ngIf="isVideo && videoDuration && viewMode === MediaLibraryMode.list">
                {{ videoDuration | date: 'mm:ss' }}
            </span>
        </div>
        <ui-svg-icon
            class="library-element-row__control"
            icon="kebab"
            *ngIf="!mediaLibrary.inDialog && isKebabNeeded"
            [uiDropdownTarget]="brandElementMenu"></ui-svg-icon>
    </div>
    <div
        class="library-element__body"
        (click)="clickToContainer()"
        [class.hidden]="viewMode === MediaLibraryMode.list">
        <div class="library-element-image">
            <div
                class="library-element__bflogo"
                *ngIf="isBannerFlowLibraryWidget">
                <ui-logo [small]="true"></ui-logo>
            </div>
            <div
                class="library-element-widget-placeholder"
                *ngIf="isWidget && !thumbnailUrl">
                <ui-svg-icon
                    icon="widget"
                    class="library-element-widget-placeholder__icon"></ui-svg-icon>
            </div>
            <div
                *ngIf="isElement || (!isElement && ers.isStyledElement(element))"
                #elementContainer></div>
            <div
                class="library-element-image__preview"
                *ngIf="!isElement && !ers.isStyledElement(element) && !isVideo"
                [style.backgroundImage]="'url(' + thumbnailUrl + ')'"></div>
            <div
                class="library-element-image__preview"
                *ngIf="isVideo"
                [style.backgroundImage]="'url(' + thumbnailUrl + ')'"></div>
            <div
                class="library-element-video-duration-preview"
                *ngIf="isVideo && videoDuration">
                {{ videoDuration | date: 'mm:ss' }}
            </div>
        </div>
    </div>
</div>

<ui-dropdown
    class="menu"
    #brandElementMenu>
    <ui-dropdown-item
        class="update-widget-option"
        svgIcon="sync-small"
        *ngIf="isWidget"
        (click)="updateWidgetInCreativeSet()"
        data-test-id="update-widget">
        Update this widget
    </ui-dropdown-item>
    <ui-dropdown-item
        svgIcon="settings"
        *ngIf="isEditable"
        (click)="emitEditElement()"
        data-test-id="edit"
        >Edit</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="copy-s"
        *ngIf="!isWidgetOrMedia"
        (click)="duplicate()"
        >Duplicate</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="plus-small"
        (click)="addElementToCanvas()"
        data-test-id="add-to-canvas"
        >Add to canvas</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="question-mark-s"
        *ngIf="isBannerFlowLibraryWidget"
        (click)="openWidgetInfo()"
        >How it works</ui-dropdown-item
    >
    <ui-dropdown-divider></ui-dropdown-divider>
    <ui-dropdown-item
        svgIcon="delete"
        *ngIf="!isBannerFlowLibraryWidget"
        (click)="deleteAsset()"
        >Delete</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="delete"
        *ngIf="isBannerFlowLibraryWidget"
        (click)="deleteAsset()"
        >Remove from library</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="edit"
        *ngIf="!isWidgetOrMedia"
        (click)="focusEditName($event)"
        >Rename</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="download"
        *ngIf="isImage || isVideo"
        (click)="downloadAsset()"
        >Download {{ element.type }}</ui-dropdown-item
    >
    <ui-dropdown-item
        svgIcon="copy-s"
        *ngIf="isImage || isVideo"
        (click)="copyAssetUrl()"
        >Copy {{ element.type }} URL</ui-dropdown-item
    >
</ui-dropdown>
